import {
  API_HOST,
  API_IMG_HOST,
  API_HOST_JAVA_SET
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101 && response.data.code != 200) {
    _g.toastMsg('error', response.data.error)
    if (response.data.code == 401) {
      // 跳转到登录页
      router.push({ path: '/login' })
    }
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})

// ====================== 视频活动 ====================== //
// 活动列表
export function getVideoActivitys (params) {
  let url = 'v2/gourmetActivity/selectListByPage'
  return axiosPhp.get(url, {
    params: params
  })
}

// 创建活动
export function createVideoActivitys (data) {
  let url = 'v2/gourmetActivity/insertActivity'
  return axiosPhp.post(url, data)
}

// 编辑
export function editVideoActivitys (data) {
  let url = 'v2/gourmetActivity/updateActivity'
  return axiosPhp.put(url, data)
}
// 活动列表 删除功能
export function deleteVideoActivitys (id) {
  let url = 'v2/gourmetActivity/deleteActivity'
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}

// 报名视频列表
export function getVideoList (params) {
  let url = 'v2/zy/vsharing/video/getListByPage'
  return axiosPhp.get(url, {
    params: params
  })
}

// 公众号管理
export function publicNumber () {
  let url = 'admin/wechat/indexApi'
  return axiosPhp.get(url)
}

